<template>
    <div class="login">
        <b-row align-v="center" align-h="center">
            <b-col md="5">

                <img alt="Vue logo" src="@/assets/logo.png" class="logo">

                <LoginWindow v-show="login" @register="showRegister" />

            </b-col>

        </b-row>


    </div>
</template>


<script>

import LoginWindow from '@/components/LoginWindow.vue'

export default {
    name: 'Login',
    components: {
        LoginWindow
    },
    data() {
        return {
            login:true,
            cardId:null,
            pin:null
        }
    },
    mounted() {


    },
    methods: {
        showRegister(data) {
            this.login = false
            this.cardId = data.cardId
            this.pin = data.pin
        },
        loginUser() {
            this.$api.post('/login', {}, {
                auth: {
                    username: this.cardId,
                    password: this.pin
                }
            })
            .then((response) => {
                this.$store.setToken(response.data.token);
                this.$store.setUser(response.data.user)

                this.$api.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.token;


                this.$router.replace('/');
            })
        }
    }
}
</script>



<style scoped lang="scss">

img {
    display: block;
    margin: 0 auto;
    max-width: 150px;
    padding: 2em 0 4em 0;
}

</style>
